import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import TextField from '@material-ui/core/TextField';
import { Box, DialogTitle, Grid, Tab, Tabs, ThemeProvider, createMuiTheme } from '@material-ui/core';
import Schedules from '../RegisterEmployee/Schedule';
import BankOfHoursAndExtraHours from '../RegisterEmployee/BankOfHoursAndExtraHours';
import Restrictions from '../RegisterEmployee/Restrictions';


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const theme = createMuiTheme({
    overrides: {
        MuiAppBar: {
            root: {
                borderBottomLeftRadius: '20px',
                borderBottomRightRadius: '20px',
                backgroundColor: '#484fdb', // Altere para a cor desejada
            },
        },
    },
});

export default function ModalConfigEmployee({
    open,
    onClose,
    viewEmployeeRegistration,
    typeModalConfig
}) {


    return (
        <div>
            <Dialog
                open={open}
                onClose={onClose}
                TransitionComponent={Transition}
                maxWidth="xl"
                scroll='body'
                PaperProps={{
                    style: {
                        borderRadius: 20, overflow: 'hidden', height: typeModalConfig == 'restrictions' ?
                            viewEmployeeRegistration.restrictions.place || viewEmployeeRegistration.restrictions.device ? 460 : 375 : typeModalConfig == 'schedule'? 600: 425, width: 800
                    },
                }}
            >
                <DialogTitle style={{ textAlign: 'center', fontFamily: 'montserrat', color: '#9e9e9e' }}>
                    {typeModalConfig == 'schedule' ? 'Configuração de escala' : typeModalConfig == 'bankOfHours' ? 'Configuração de Banco de Horas' : 'Configuração de Restrições'}
                </DialogTitle>
                <div style={{ marginTop: 17 }}>
                    {
                        typeModalConfig == 'schedule' ?
                            <Schedules viewEmployeeRegistration={viewEmployeeRegistration} isModal={true}/>
                            : null
                    }
                    {
                        typeModalConfig == 'bankOfHours' ?
                            <BankOfHoursAndExtraHours viewEmployeeRegistration={viewEmployeeRegistration} />
                            : null
                    }
                    {
                        typeModalConfig == 'restrictions' ?
                            <Restrictions viewEmployeeRegistration={viewEmployeeRegistration} />
                            : null
                    }
                </div>

            </Dialog>
        </div>
    );
}
